// extracted by mini-css-extract-plugin
module.exports = {"AnchorLinkWrapper":"AnchorLinkWrapper"};